<template>
  <div ref="container">
    <div
      v-if="overlayValue"
      class="modal-drop"
      :style="{ padding: modalPadding + 'vh 0' }"
      @click="checkOutside"
    >
      <div class="row dismiss-modal">
        <div class="flex md12 dismiss-modal">
          <va-card
            v-if="!computeCampagne"
            class="modal-container dismiss-modal"
            :style="{ width: modalWidth + 'vw', height: modalHeight + 'vh' }"
          >
            <div class="mb-4 title" :style="{ color: this.$themes.primary }">
              Gestion de l'envoi des bulletins d'adhésion
            </div>
            <div class="row row-inside">
              <div class="flex md2">Enseigne :</div>
              <div class="flex md10">
                {{ infoentreprise ? infoentreprise.nom : "" }}
              </div>
              <div class="flex md2">Gérant :</div>
              <div class="flex md10">
                {{ infoentreprise ? infoentreprise.contact_siege_nom : "" }}
              </div>
              <div
                class="flex md2"
                v-if="infoentreprise && infoentreprise.idcontact_main"
              >
                Contact principal :
              </div>
              <div
                class="flex md10"
                v-if="infoentreprise && infoentreprise.idcontact_main"
              >
                {{ infoentreprise ? infoentreprise.contact_main_nom : "" }}
              </div>
              <div class="flex md2">Code APE :</div>
              <div class="flex md10">
                {{
                  infoentreprise
                    ? infoentreprise.code === "4638A"
                      ? "4638A - Grossiste"
                      : infoentreprise.code
                    : ""
                }}
              </div>
              <div class="row row-inside" v-if="norelance">
                <div class="flex flex-center md12 mt-4">
                  <h1 class="flex-center">Entreprise non relançable</h1>
                </div>
              </div>
              <div
                class="row row-inside md12 mt-4"
                v-if="!norelance && infoentreprise"
              >
                <div
                  class="flex md6 divider-right"
                  :style="{
                    height: modalHeight * 0.5 + 'vh',
                  }"
                >
                  <div class="row row-inside">
                    <div class="flex md12 mb-2">
                      <h1 class="flex-center">SPEF</h1>
                    </div>
                    <div
                      class="flex md6 offset--md3 mb-1"
                      v-if="infoentreprise && infoentreprise.date_fin_spef"
                    >
                      <va-badge
                        :color="colorAdhesion(date_fin_spef)"
                        class="fullwidth"
                        :outline="
                          date_fin_spef.isBefore(moment().add(1, 'month'))
                        "
                      >
                        {{
                          date_fin_spef.isBefore(moment())
                            ? "Expiré - " + date_fin_spef.format("DD-MM-YYYY")
                            : date_fin_spef.format("DD-MM-YYYY")
                        }}</va-badge
                      >
                    </div>
                    <div
                      class="flex md6 offset--md3"
                      v-if="infoentreprise && infoentreprise.niveau_spef"
                    >
                      <va-badge
                        :color="colorEnvoi(infoentreprise.niveau_spef)"
                        class="fullwidth"
                        >Niveau {{ infoentreprise.niveau_spef }}</va-badge
                      >

                      <p class="last-send flex-center">
                        {{
                          moment(infoentreprise.date_envoi_spef).format(
                            "DD-MM-YYYY"
                          )
                        }}
                      </p>
                      <va-button
                        class="fullwidth"
                        v-on:click.middle="openPdf(infoentreprise.idenvoi_spef)"
                        @click="downloadPdf(infoentreprise.idenvoi_spef)"
                        >Télécharger le bulletin</va-button
                      >
                    </div>
                    <div class="flex md12 my-4"></div>

                    <div
                      class="flex md6 offset--md3 mt-4"
                      v-if="!relancableSpef"
                    >
                      <h1 class="flex-center">Non prospectable</h1>
                    </div>
                    <div
                      class="flex md6 offset--md3 mt-4"
                      v-else-if="
                        moment(infoentreprise.date_envoi_spef)
                          .add(2, 'weeks')
                          .isAfter(moment())
                      "
                    >
                      <h1 class="flex-center">
                        Non relançable - attendre
                        {{
                          moment(infoentreprise.date_envoi_spef)
                            .add(2, "weeks")
                            .diff(moment(), "days")
                        }}
                        jours
                      </h1>
                    </div>
                    <div class="flex md6 offset--md3" v-else>
                      <div class="row row-inside">
                        <div class="flex md6">
                          <va-checkbox
                            :disabled="
                              !infoentreprise.entreprise_email &&
                              !infoentreprise.maincontact_email
                            "
                            v-model="emailSpef"
                            label="Email"
                          />
                        </div>

                        <div class="flex md6">
                          <va-checkbox
                            :disabled="!!infoentreprise.nocourrier"
                            v-model="courrierSpef"
                            label="Courrier"
                          />
                        </div>
                        <div class="flex md12 mt-4">
                          <va-button
                            class="fullwidth"
                            :disabled="!courrierSpef && !emailSpef"
                            @click="envoiBulletin('spef')"
                            >Envoyer</va-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md6">
                  <div class="row row-inside">
                    <div class="flex md12 mb-2">
                      <h1 class="flex-center">UNPF</h1>
                    </div>
                    <div
                      class="flex md6 offset--md3 mb-1"
                      v-if="infoentreprise && infoentreprise.date_fin_unpf"
                    >
                      <va-badge
                        :color="colorAdhesion(date_fin_unpf)"
                        class="fullwidth"
                        :outline="
                          date_fin_unpf.isBefore(moment().add(1, 'month'))
                        "
                      >
                        {{
                          date_fin_unpf.isBefore(moment())
                            ? "Expiré - " + date_fin_unpf.format("DD-MM-YYYY")
                            : date_fin_unpf.format("DD-MM-YYYY")
                        }}</va-badge
                      >
                    </div>
                    <div
                      class="flex md6 offset--md3"
                      v-if="infoentreprise && infoentreprise.niveau_unpf"
                    >
                      <va-badge
                        :color="colorEnvoi(infoentreprise.niveau_unpf)"
                        class="fullwidth"
                        >Niveau {{ infoentreprise.niveau_unpf }}</va-badge
                      >

                      <p class="last-send flex-center">
                        {{
                          moment(infoentreprise.date_envoi_unpf).format(
                            "DD-MM-YYYY"
                          )
                        }}
                      </p>
                      <va-button
                        class="fullwidth"
                        v-on:click.middle="openPdf(infoentreprise.idenvoi_unpf)"
                        @click="downloadPdf(infoentreprise.idenvoi_unpf)"
                        >Télécharger le bulletin</va-button
                      >
                    </div>
                    <div class="flex md12 my-4"></div>

                    <div
                      class="flex md6 offset--md3 mt-4"
                      v-if="!relancableUnpf"
                    >
                      <h1 class="flex-center">Non prospectable</h1>
                    </div>
                    <div
                      class="flex md6 offset--md3 mt-4"
                      v-else-if="
                        moment(infoentreprise.date_envoi_unpf)
                          .add(2, 'weeks')
                          .isAfter(moment())
                      "
                    >
                      <h1 class="flex-center">
                        Non relançable - attendre
                        {{
                          moment(infoentreprise.date_envoi_unpf)
                            .add(2, "weeks")
                            .diff(moment(), "days")
                        }}
                        jours
                      </h1>
                    </div>
                    <div class="flex md6 offset--md3" v-else>
                      <div class="row row-inside">
                        <div class="flex md6">
                          <va-checkbox
                            :disabled="
                              !infoentreprise.entreprise_email &&
                              !infoentreprise.maincontact_email
                            "
                            v-model="emailUnpf"
                            label="Email"
                          />
                        </div>

                        <div class="flex md6">
                          <va-checkbox
                            :disabled="!!infoentreprise.nocourrier"
                            v-model="courrierUnpf"
                            label="Courrier"
                          />
                        </div>
                        <div class="flex md12 mt-4">
                          <va-button
                            class="fullwidth"
                            :disabled="!courrierUnpf && !emailUnpf"
                            @click="envoiBulletin('unpf')"
                            >Envoyer</va-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md12">
                <div class="row row-inside bottom-row">
                  <div class="flex md2 offset--md4">
                    <va-button
                      class="fullwidth"
                      color="gray"
                      flat
                      @click="cancel"
                      >Annuler</va-button
                    >
                  </div>
                  <div class="flex md2">
                    <va-button @click="close" class="fullwidth"
                      >Fermer</va-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </va-card>
          <va-card
            class="modal-container dismiss-modal"
            :style="{ width: modalWidth + 'vw', height: modalHeight + 'vh' }"
            v-if="computeCampagne && !displayError"
          >
            <h4>Génération du document en cours, veuillez patienter</h4>
            <br />
            <va-progress-bar :value="valueProgress" />
          </va-card>
          <va-card
            class="modal-container dismiss-modal"
            :style="{ width: modalWidth + 'vw', height: modalHeight + 'vh' }"
            v-if="displayError"
          >
            <br />
            <br />
            <h4>
              Une erreur semble avoir survenue lors du document. Veuillez
              patienter 15min, rafraichir la page et regarder dans l'onglet
              archive si les envois ont été générés.
            </h4>
            <br />
            <br />
          </va-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "envoiBulletinsAdhesions",
  props: {
    value: {
      required: true,
      default: false,
    },
    identreprise: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      moment: moment,
      modalWidth: 60,
      modalHeight: 60,
      overlayValue: false,
      pdfurl: "",
      disableActions: false,
      disableEmail: false,
      infoentreprise: null,
      limitReserve: moment().subtract(5, "years"),
      startRelance: moment().add(1, "month"),
      emailSpef: false,
      courrierSpef: false,
      emailUnpf: false,
      courrierUnpf: false,
      valueProgress: false,
      computeCampagne: false,
      displayError: false,
    };
  },
  mounted() {
    document.body.appendChild(this.$refs.container);
  },
  computed: {
    date_norelance_spef() {
      if (this.infoentreprise && this.infoentreprise.date_norelance_spef) {
        return moment(this.infoentreprise.date_norelance_spef, "YYYY-MM-DD");
      } else {
        return null;
      }
    },
    date_norelance_unpf() {
      if (this.infoentreprise && this.infoentreprise.date_norelance_unpf) {
        return moment(this.infoentreprise.date_norelance_unpf, "YYYY-MM-DD");
      } else {
        return null;
      }
    },
    date_fin_spef() {
      if (this.infoentreprise && this.infoentreprise.date_fin_spef) {
        return moment(this.infoentreprise.date_fin_spef, "YYYY-MM-DD");
      } else {
        return null;
      }
    },
    date_fin_unpf() {
      if (this.infoentreprise && this.infoentreprise.date_fin_unpf) {
        return moment(this.infoentreprise.date_fin_unpf, "YYYY-MM-DD");
      } else {
        return null;
      }
    },
    relancableUnpf() {
      if (!this.infoentreprise) {
        return false;
      }
      if (!this.date_fin_spef && !this.date_fin_unpf) {
        return true;
      } else if (
        !this.date_fin_spef &&
        this.date_fin_unpf.isBefore(this.startRelance)
      ) {
        return true;
      } else if (!this.date_fin_spef) {
        //firm have an active adhesion // check that date_fin_unpf exist
        return false;
      } else if (
        this.date_fin_unpf &&
        this.date_fin_unpf.isBefore(this.startRelance) &&
        (this.date_fin_unpf.isAfter(this.limitReserve) ||
          this.date_fin_spef.isBefore(this.limitReserve))
      ) {
        return true;
      } else {
        return false;
      }
    },
    relancableSpef() {
      if (!this.infoentreprise) {
        return false;
      }
      if (!this.date_fin_unpf && !this.date_fin_spef) {
        return true;
      } else if (
        !this.date_fin_unpf &&
        this.date_fin_spef.isBefore(this.startRelance)
      ) {
        return true;
      } else if (!this.date_fin_unpf) {
        //firm have an active adhesion // check that date_fin_unpf exist
        return false;
      } else if (
        this.date_fin_spef &&
        this.date_fin_spef.isBefore(this.startRelance) &&
        (this.date_fin_spef.isAfter(this.limitReserve) ||
          this.date_fin_unpf.isBefore(this.limitReserve))
      ) {
        return true;
      } else {
        return false;
      }
    },
    norelance() {
      if (!this.infoentreprise) {
        return true;
      } else if (
        this.infoentreprise.norelance ||
        this.infoentreprise.norelance_lies
      ) {
        return true;
      } else if (
        this.date_norelance_spef &&
        this.date_norelance_unpf &&
        this.date_norelance_spef.isSameOrAfter(moment()) &&
        this.date_norelance_unpf.isSameOrAfter(moment())
      ) {
        return true;
      } else if (
        (!this.relancableUnpf &&
          this.date_norelance_spef &&
          this.date_norelance_spef.isSameOrAfter(moment())) ||
        (!this.relancableSpef &&
          this.date_norelance_unpf &&
          this.date_norelance_unpf.isSameOrAfter(moment()))
      ) {
        return true;
      } else {
        return false;
      }
    },
    modalPadding() {
      let halfHeight = 100 - this.modalHeight;
      return halfHeight / 2;
    },
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.overlayValue = true;
        window.addEventListener("keyup", this.listenKeyUp);
        if (this.identreprise) {
          this.loadInfos();
        }
      } else {
        this.overlayValue = false;
        window.removeEventListener("keyup", this.listenKeyUp);
        this.pdfurl = "";
      }
    },
    identreprise(value) {
      console.log("load adhesions");
      if (value) {
        this.loadInfos();
        this.valueProgress = false;
        this.computeCampagne = false;
        this.displayError = false;
      }
    },
  },
  methods: {
    async envoiBulletin(syndicat) {
      try {
        if (syndicat !== "spef" && syndicat !== "unpf") {
          this.showToast("Syndicat non reconnu", {
            position: "bottom-center",
            duration: 5000,
          });
          return null;
        }
        this.valueProgress = 0;
        this.computeCampagne = true;
        this.updateProgress();
        let params = {
          identreprise: this.identreprise,
          grossiste: this.infoentreprise.code === "4638A",
          syndicat: syndicat,
        };
        if (syndicat === "spef") {
          params.sendemail = this.emailSpef;
          params.sendcourrier = this.courrierSpef;
          if (
            !this.infoentreprise.date_fin_spef ||
            this.date_fin_spef.isBefore(moment().subtract(1, "year"))
          ) {
            params.campaignType = "getAll";
          } else {
            params.campaignType = "renouvellement";
          }
        } else if (syndicat === "unpf") {
          params.sendemail = this.emailUnpf;
          params.sendcourrier = this.courrierUnpf;
          if (
            !this.infoentreprise.date_fin_unpf ||
            this.date_fin_unpf.isBefore(moment().subtract(1, "year"))
          ) {
            params.campaignType = "getAll";
          } else {
            params.campaignType = "renouvellement";
          }
        }

        let res = await axios.post("/api/campagne/send-bulletin", params);
        this.loadInfos();
        let url = res.data.pdfUrl;
        let errorEmail = res.data.emailError;
        if (!errorEmail) {
          this.launchEpicmaxToast("Courriels envoyés");
        } else {
          this.launchEpicmaxToast(
            "Courriels non envoyés: " +
              errorEmail +
              " vérifier dans l’onglet archives"
          );
        }

        if (url !== "no pdf") {
          window.open(url, "_blank");
          this.downloadItem(url, "Bulletins " + this.syndicat);
        }

        this.computeCampagne = false;
        this.valueProgress = 0;
      } catch (error) {
        this.showToast("Une erreur est survenue lors de l'envoi", {
          position: "bottom-center",
          duration: 5000,
        });
        this.displayError = true;
        console.log(error);
      }
    },
    async updateProgress() {
      setInterval(() => {
        this.valueProgress += 1;
      }, 400);
    },
    colorAdhesion(dateFin) {
      if (dateFin.isAfter(moment().add(1, "month"))) {
        return "success";
      }
      if (dateFin.isBefore(moment())) {
        return "danger";
      }

      return "warning";
    },
    colorEnvoi(niveau) {
      if (niveau === 1) {
        return "success";
      }
      if (niveau === 2) {
        return "warning";
      }
      return "danger";
    },
    async loadInfos() {
      try {
        this.emailSpef = false;
        this.courrierSpef = false;
        this.emailUnpf = false;
        this.courrierUnpf = false;

        this.disableActions = true;
        console.log(this.identreprise);
        let res = await axios.get("/api/campagnes/infos-campagne-entreprise", {
          params: {
            identreprise: this.identreprise,
          },
        });
        this.disableActions = false;
        this.infoentreprise = res.data;
        console.log(this.infoentreprise);
      } catch (err) {
        this.showToast("Erreur lors du chargement des campagnes d'adhésion", {
          position: "bottom-center",
          duration: 5000,
        });
      }
    },
    async getPdfUrl(idenvoi) {
      try {
        let response = await axios.get("/api/campagnes/pdfenvoi", {
          params: { idenvoi: idenvoi },
        });
        return response.data;
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors du téléchargement");
      }
    },
    async openPdf(idenvoi) {
      let url = await this.getPdfUrl(idenvoi);
      window.open(url, "_blank");
    },
    async downloadPdf(idenvoi) {
      let url = await this.getPdfUrl(idenvoi);
      this.downloadItem(url);
    },
    async openNewTab(url) {
      try {
        window.open(url, "_blank");
        this.ok();
      } catch (err) {}
    },

    downloadItem(url) {
      let name = "Bulletin " + this.infoentreprise.nom;
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },

    close() {
      this.disableActions = false;
      this.valueProxy = false;
    },
    cancel() {
      this.emailSpef = false;
      this.courrierSpef = false;
      this.emailUnpf = false;
      this.courrierUnpf = false;
      this.close();

      this.$emit("cancel");
    },
    ok() {
      this.close();
      this.$emit("ok");
    },
    listenKeyUp(e) {
      if (e.code === "Escape" && !this.noEscDismiss) {
        this.cancel();
      }
    },
    checkOutside(e) {
      if (!this.noOutsideDismiss) {
        let modal;
        e.target.childNodes.forEach((node) => {
          if (node.classList && node.classList.contains("dismiss-modal")) {
            modal = node;
          }
        });
        if (modal && !this.disableActions) {
          this.cancel();
        }
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style >
.modal-drop {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-container {
  box-shadow: $widget-box-shadow;
  z-index: 1001;
  position: relative;
  margin: auto;
}
.solid {
  border: 2px solid #4ab2e3;
  border-radius: 25px;
  position: relative;
}
.solid:hover {
  cursor: pointer;
  background: #e5f5fa;
}
.fullsize {
  width: 100%;
  height: 95%;
}
.center-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.setheight {
  height: 60vh;
}

.fullwidth {
  width: 95%;
}

.bottom-row {
  width: 100%;
  margin-bottom: 15px;
  padding: 0;
  position: absolute;
  bottom: 0;
}

.divider-right {
  border-right: 2px solid #ccc;
}
</style>
